export const productsData = [
  {
    id: 1,
    name: "Potassium Bicarbonate Technical Grade",
    price: "₹80/kg",
    description:
      "Technical Grade, 25kg HDPE Bag. White powder, high purity (99.5%) industrial potassium bicarbonate (KHCO3). Used as leavening agent, fire extinguishing agent, and in pharmaceutical and industrial processes.",
    category: "chemicals",
    keywords: [
      "potassium",
      "bicarbonate",
      "KHCO3",
      "technical",
      "industrial",
      "leavening",
      "fire extinguisher",
    ],
    image: "/images/Potassium Bicarbonate Technical Grade.webp",
  },
  {
    id: 2,
    name: "Potassium Carbonate Industrial Grade",
    price: "₹125/kg",
    description:
      "Industrial Grade, 25kg HDPE Bag. White granules, high purity (99%) potassium carbonate (K2CO3) for industrial use. Used in glass making, fertilizers, and chemical industry.",
    category: "chemicals",
    keywords: [
      "potassium",
      "carbonate",
      "K2CO3",
      "industrial",
      "glass",
      "fertilizer",
    ],
    image: "/images/Potassium Carbonate Technical Grade.webp",
  },
  {
    id: 3,
    name: "Ammonium Molybdate Powder",
    price: "₹1,400/kg",
    description:
      "98% pure ammonium molybdate (NH4)2MoO4, 25kg HDPE Bag. Used in industrial processes. White powder with molar mass 196.02 g/mol and melting point 81°C.",
    category: "chemicals",
    keywords: ["ammonium", "molybdate", "NH4", "MoO4", "industrial", "powder"],
    image: "/images/Ammonium Molybdate Powder.webp",
  },
  {
    id: 4,
    name: "Magnesium Oxide Powder",
    price: "Contact for price",
    description:
      "85% pure magnesium oxide (MgO), 50kg HDPE Bag. White, odorless, tasteless powder for industrial applications. Net weight 50 kg. Shelf life 1 year.",
    category: "chemicals",
    keywords: ["magnesium", "oxide", "MgO", "industrial", "powder", "compound"],
    image: "/images/Magnesium Oxide Powder.webp",
  },
  {
    id: 5,
    name: "Sodium Molybdate Powder",
    price: "Contact for price",
    description:
      "99.5% pure sodium molybdate (Na2MoO4), 25kg HDPE Bag. White powder used in industrial applications. Molar mass 205.92 g/mol. Shelf life 1 year.",
    category: "chemicals",
    keywords: [
      "sodium",
      "molybdate",
      "Na2MoO4",
      "industrial",
      "powder",
      "compound",
    ],
    image: "/images/Sodium Molybdate Powder.webp",
  },
  {
    id: 6,
    name: "Ammonium Chloride Technical Grade",
    price: "Contact for price",
    description:
      "Technical Grade, 25kg Bag. White crystalline powder (NH4Cl), purity 99%, molecular weight 53.49 g/mol. Used in food industry, fertilizers, and various industrial applications.",
    category: "chemicals",
    keywords: [
      "ammonium",
      "chloride",
      "NH4Cl",
      "food industry",
      "technical",
      "fertilizer",
      "industrial",
    ],
    image: "/images/Ammonium Chloride Powder.webp",
  },
  {
    id: 7,
    name: "Phosphorous Acid",
    price: "Contact for price",
    description:
      "Phosphorous Acid (H3PO3), white crystalline powder. Used as an intermediate in chemical synthesis, for production of phosphonates, and as a reducing agent in industrial applications.",
    category: "chemicals",
    keywords: [
      "phosphorous",
      "acid",
      "H3PO3",
      "intermediate",
      "phosphonates",
      "reducing agent",
      "industrial",
      "compound",
    ],
    image: "/images/Phosphoric Acid.webp",
  },
  {
    id: 8,
    name: "Potassium Humate Flakes",
    price: "Contact for price",
    description:
      "Organic Potassium Humate Flakes, 98% soluble, black shiny flakes. 25kg bags. Enhances soil fertility and plant growth. Used in agriculture as a soil conditioner and fertilizer enhancer.",
    category: "chemicals",
    keywords: [
      "potassium",
      "humate",
      "flakes",
      "organic",
      "fertilizer",
      "agriculture",
      "soil enhancer",
    ],
    image: "/images/potassium-humate-flakes.jpeg",
  },
  {
    id: 9,
    name: "Potassium Humate Powder",
    price: "Contact for price",
    description:
      "Fine black powder, 100% soluble Potassium Humate. Supplied in 25kg bags. Used in soil conditioning, plant nutrition, and crop improvement in agriculture.",
    category: "chemicals",
    keywords: [
      "potassium",
      "humate",
      "powder",
      "agriculture",
      "plant nutrition",
      "fertilizer",
      "soil",
    ],
    image: "/images/Potassium Humate Powder.webp",
  },
  {
    id: 10,
    name: "Sodium Humate Flakes",
    price: "Contact for price",
    description:
      "Sodium Humate Flakes, dark brown to black, water-soluble, supplied in 25kg bags. Acts as a chelating agent and improves nutrient uptake. Widely used in animal feed and agriculture.",
    category: "chemicals",
    keywords: [
      "sodium",
      "humate",
      "flakes",
      "animal feed",
      "fertilizer",
      "chelating",
      "agriculture",
    ],
    image: "/images/Sodium Humate Flakes.jpg",
  },
  {
    id: 11,
    name: "Potassium Fulvate",
    price: "Contact for price",
    description:
      "Potassium Fulvate is a water-soluble organic potassium compound. Supplied in 25kg bags. Promotes plant metabolism, enhances nutrient absorption, and improves crop yield.",
    category: "chemicals",
    keywords: [
      "potassium",
      "fulvate",
      "organic",
      "fertilizer",
      "plant growth",
      "soil conditioner",
      "agriculture",
    ],
    image: "/images/Potassium Fulvate Powder.webp",
  },
];